import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import days from './days.json'
import months from './months.json'
import weeks from './weeks.json'
import years from './years.json'
import { DOC2SIGN_DOCUMENT_TYPE } from '../constants';
import { CFDI_MASIVO } from '../constants';
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
const fieldTypes = [
    {
        id: 'text',
        title: 'Texto',
        icon: 'fa-font'
    },
    {
        id: 'email',
        title: 'Email',
        icon: 'fa-font'
    },
    {
        id: 'paragraph',
        title: 'Párrafo',
        icon: 'fa-paragraph'
    },
    {
        id: 'date',
        title: 'Fecha',
        icon: 'fa-calendar'
    },
    {
        id: 'number',
        title: 'Número',
        icon: 'fa-number'
    } 
];
class DocumentFieldView extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            isIconUp: false,
        }; 
    }

    async componentDidMount() {
      
    } 
    getIconForType(typeId) {
        for (const t of fieldTypes) {
            if (typeId == t.id) {
                return t.icon;
            }
        }
    }
    handleToggleIcon = () => {
        this.setState((prevState) => ({
            isIconUp: !prevState.isIconUp,
        }));
    };
    formatValidationValue(value) {
        if(value == null)
        {
            return ''
        }
        try {
            const parsedValue = JSON.parse(value);
            if (Array.isArray(parsedValue) && parsedValue.length === 2) {
                let trans 
                if(parsedValue[1] == 'day'){
                    trans = ' día(s)'
                }
                if(parsedValue[1] == 'week'){
                    trans = ' semana(s)'
                }
                if(parsedValue[1] == 'month'){
                    trans = ' mes(s)'
                }
                if(parsedValue[1] == 'year'){
                    trans = ' año(s)'
                }
                if(parsedValue[1] == 'day'){
                    trans = ' día(s)'
                }
                return " :" +  parsedValue[0] + trans;
            }
        } catch (error) {
          // No es un array válido, trata el valor como string
        }
        return ': ' + value;
      }
      translate(tipo) { 
            switch (tipo) {
            case 'number':
                return 'Número';
            case 'text':
                return 'Texto';
            case 'email':
                return 'Email';
            case 'paragraph':
                return 'Párrafo';
            case 'date':
                return 'Fecha';
            default:
                return tipo; // Si no es ninguno de los anteriores, devolver el valor original
    }
  }
    render() { 
        const { isIconUp } = this.state;
        const iconClass = isIconUp ? "flaticon2-up" : "flaticon2-down";
        const { lang } = this.context;
        return (
            <div   className="   mb-3">
            <div style={{ borderBottom: '1px solid #d5d5d5' }} >
                <div className="p-5  mb-3" >
                    <div className="d-flex justify-content-between align-items-center" id="headingOne">
                        <div className="d-flex align-items-center ">
                        {this.props.field.document_field_type == 'number' &&
                                    <svg className="w-30px" width="8" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.63202 19.9948C4.6268 19.8959 4.62159 19.8022 4.62159 19.7034C4.62159 15.6232 4.62159 11.5483 4.62159 7.46812C4.62159 7.38486 4.62159 7.30159 4.62159 7.21832C4.52248 7.1975 4.47553 7.26516 4.42337 7.30679C3.14017 8.24356 1.71093 8.87328 0.203441 9.34686C0.0365213 9.39891 0 9.34686 0 9.19074C0.00521623 7.81681 0.00521623 6.44809 0 5.07416C0 4.90762 0.0782486 4.85558 0.213871 4.80874C1.73179 4.30913 3.02021 3.44523 4.13126 2.3159C4.71548 1.72261 5.12756 1.02004 5.38837 0.228988C5.44575 0.057247 5.524 0 5.70656 0C6.85935 0.0104085 8.01213 0.0104085 9.17014 0C9.37357 0 9.42052 0.0624512 9.42052 0.255009C9.4153 6.77075 9.4153 13.2917 9.4153 19.8074C9.4153 19.8699 9.40487 19.9375 9.40487 20C7.81392 19.9948 6.22297 19.9948 4.63202 19.9948Z" fill="#C2C2C2"/>
                                </svg>
                                    }
                                    {this.props.field.document_field_type != 'number' &&
                                    <i className={`fa ${this.getIconForType(this.props.field.document_field_type)} icon w-30px`}></i>
                                    }
                            <span className="text-muted w-50px"> 
                                    {lang.get('messages.'+this.translate(this.props.field.document_field_type).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""))}
                            </span>  
                            <strong className="ml-2">{(this.props.document.type_id >= 5 && this.props.document.type_id <= 15) ? this.props.field.placeholder : this.props.field.title}</strong>
                        </div> 
                        <div className="text-center">
                            {(this.props.document.document_field_validation_id == this.props.field.id) && 
                            <span>   <i className={`flaticon2-calendar-5 text-warning mr-2 icon w-30px`}></i> {lang.get('messages.esta_fecha_sera_la_caducidad_del_documento')}</span>
                            }  
                        </div>
                        <div className="d-flex align-items-center">
                            <span className="float-right mr-2">{lang.get('messages.validacion_automatica')}:   <b>
                                {this.props.field.validations.length > 0 && lang.get('messages.si')}
                                {this.props.field.validations.length == 0 && 'No'} </b>
                            </span> 
                            {this.props.field.validations.length > 0 &&
                            <a  data-toggle="collapse"  onClick={this.handleToggleIcon} data-target={`#collapse${this.props.field.id}`}
                                                aria-expanded="false" aria-controls="collapseOne"   target="_blank"   className="float-right mr-1 btn btn-icon btn-secondary btn-xs mr-2 visor-button">
                                    <i className={`${iconClass} text-primary`}></i>
                                </a>
                            } 
                        </div>
                    </div>
                </div>
                <div id={`collapse${this.props.field.id}`} className="collapse   p-5" aria-labelledby="headingOne"> 
                    <div className="mt-3 pl-5">
                        {this.props.field.validations.map(validation=>  {
                            return <>
                                {validation.internal_validation.description}    
                                {this.formatValidationValue(validation.value)}
                                <br/>
                            </>
                        })}
                    </div>
                </div> 
            </div>
        </div> 
        );
    }
}

export default DocumentFieldView;

if (document.getElementById('DocumentFieldView')) {
    ReactDOM.render(<DocumentFieldView />, document.getElementById('DocumentFieldView'));
}
